import { MenuOutlined } from '@ant-design/icons';
import { useCurrentUser } from '@framework/auth';
import { useTranslation } from '@framework/i18n';
import { Dropdown, useHistory } from '@framework/ui';
import type { ItemType, MenuItemType } from 'antd/es/menu/interface';
import { default as React, useMemo, useState } from 'react';
import { MobileMenuLabel } from '../../ui/menu/MobileMenuLabel';
import { TopMenuIconButton } from '../../ui/menu/TopMenuIconButton';
import { LoginButton } from './LoginButton';
import { useMainMenuItem } from './useMainMenuItem';
import { useUserMenuItems } from './useUserMenuItems';

export interface MobileFullMenuProps {
  extra?: React.ReactNode;
}
/**
 * Pulsante Dropdown  mostrato in modalità Mobile
 * per il menu principale e per il logout dell'utente lato compilazione
 */
export function MobileFullMenu(props: MobileFullMenuProps) {
  const currentUser = useCurrentUser();
  const history = useHistory();
  const userMenuItem = useUserMenuItems();
  const { t } = useTranslation();
  const [menuVisible, setMenuVisible] = useState(false);

  const mainMenuItemsBase = useMainMenuItem();

  const mainMenuItems = useMemo<ItemType[]>(() => {
    return mainMenuItemsBase.map(item => {
      return {
        key: item.menuKey,
        label: (
          <MobileMenuLabel aria-label={item.title}>
            {item.children}
          </MobileMenuLabel>
        ),
        title: item.title,
        onClick: () => {
          history.push(item.to);
        },
      } as ItemType;
    });
  }, [history, mainMenuItemsBase]);

  const menu = useMemo(() => {
    const wrappedItems = userMenuItem.items.map(item => {
      const baseItem = item as MenuItemType;
      return {
        ...baseItem,
        label: (
          <MobileMenuLabel aria-label={baseItem.title}>
            {baseItem?.label}
          </MobileMenuLabel>
        ),
        icon: undefined,
      } as ItemType;
    });
    const result = [...mainMenuItems, ...wrappedItems];

    return { items: result };
  }, [mainMenuItems, userMenuItem.items]);

  return currentUser ? (
    <nav id="mobile-full-menu">
      <Dropdown
        autoFocus
        placement="bottomRight"
        menu={menu}
        trigger={['click']}
        arrow
        onOpenChange={open => {
          setMenuVisible(open);
        }}
      >
        <TopMenuIconButton
          aria-expanded={menuVisible}
          aria-haspopup
          aria-label={t('menu.principal-menu', 'Menu Principale')}
          size="large"
          icon={<MenuOutlined aria-hidden="true" />}
        />
      </Dropdown>
    </nav>
  ) : (
    <LoginButton />
  );
}
